module.exports = __webpack_public_path__ + "img/medlabo_panel1.76214cdd.png";